import Swiper from "swiper";
import {
  BREAKPOINT_PHONE,
  BREAKPOINT_TABLET,
  BREAKPOINT_DESKTOP_LG,
  BREAKPOINT_DESKTOP
} from "../util/constants";

export default class TabSlider {
  constructor(elem) {
    this.elem = $(elem);
    this.swiper = null;

    let that = this;

    if (window.innerWidth >= BREAKPOINT_DESKTOP) {
      // Activate default tab.
      this.activateTab(0);
    } else {
      this.activateTab(0, true);
    }

    // Handle tab clicks.
    this.elem.find(".tab-slider-tabs li").click(function() {
      if ($(this).data("link")) {
        return;
      }
      if ($(this).data("open-search") === 1) {
        window.eventBus.$emit("toggle-select");
        return;
      }

      that.activateTab($(this).data("tab-id"));
    });

    // Initialize swiper.
    $(window).on("load", () => {
      that.swiper = new Swiper(this.elem.find(".swiper-container"), {
        slidesPerView: 6,
        spaceBetween: 27,
        navigation: {
          nextEl: that.elem.find(".swiper-button-next"),
          prevEl: that.elem.find(".swiper-button-prev")
        },
        pagination: {
          el: that.elem.find(".swiper-pagination"),
          type: "bullets"
        },

        // Disable preloading of all images.
        preloadImages: false,

        // Enable lazy loading.
        lazy: true,

        breakpoints: {
          [BREAKPOINT_PHONE]: {
            slidesPerView: 1.5,
            spaceBetween: 10
          },
          [BREAKPOINT_DESKTOP]: {
            slidesPerView: 3,
            spaceBetween: 27
          },
          [BREAKPOINT_DESKTOP_LG]: {
            slidesPerView: 4,
            spaceBetween: 27
          }
        }
      });
    });
  }

  activateTab(id, activeButNotCollapsed = false) {
    if (!this.elem.hasClass("collapsed") && !activeButNotCollapsed) {
      // Trigger collapse animation on mobile.
      // this.elem.addClass("collapsed");
    } else {
      this.elem.addClass("active-not-collapsed");
    }

    let tabs = this.elem.find(".tab-slider-tabs");
    const tabsItem = tabs.find("[data-tab-id=" + id + "]");

    const span = tabsItem.find("span");

    let text = span.text();

    if (span.data("title-mobile") && span.data("title-mobile").length > 0) {
      text = span.data("title-mobile");
    }

    this.elem.find(".tab-slider-title").text(text);

    // Add 'active' class to tab.
    tabs.find("li.active").removeClass("active");
    tabsItem.addClass("active");

    // Show only the active tab's slides.
    this.elem
      .find(".swiper-container .swiper-slide")
      .hide()
      .filter("[data-tab-id=" + id + "]")
      .show();

    // Recalculate slider.
    if (this.swiper) {
      this.swiper.update();
    }
  }
}
